const REMOTE_PRODUCTS_API_URL = "https://dummyjson.com/products?limit=194";
const REQUEST_TIMEOUT_MS = 1800;
const REMOTE_REQUEST_TIMEOUT_MS = 2500;

const FALLBACK_PRODUCT_IMAGE =
  "data:image/svg+xml;utf8," +
  encodeURIComponent(`
    <svg xmlns="http://www.w3.org/2000/svg" width="640" height="640" viewBox="0 0 640 640">
      <rect width="640" height="640" rx="36" fill="#eef4ff"/>
      <rect x="120" y="110" width="400" height="420" rx="28" fill="#ffffff" stroke="#c7d2fe" stroke-width="12"/>
      <rect x="225" y="150" width="190" height="24" rx="12" fill="#dbeafe"/>
      <rect x="185" y="210" width="270" height="190" rx="18" fill="#e0e7ff"/>
      <circle cx="320" cy="305" r="56" fill="#93c5fd"/>
      <rect x="205" y="440" width="230" height="18" rx="9" fill="#cbd5e1"/>
      <rect x="245" y="478" width="150" height="18" rx="9" fill="#e2e8f0"/>
    </svg>
  `);

const FALLBACK_CATEGORY_CONFIG = [
  {
    category: "Phones & Tablets",
    products: [
      {
        id: 101,
        brand: "Samsung",
        name: "Galaxy M14 5G",
        imageUrl: "https://rukminim2.flixcart.com/image/832/832/xif0q/mobile/g/b/s/-original-imagzm8qmr7qxfhq.jpeg?q=70&crop=false",
        description: "5G smartphone with large battery and dependable everyday performance.",
        price: 14999,
        discount: 18,
        stock: 28,
        color: "Blue",
        specs: { ram: "6GB", storage: "128GB", battery: "6000mAh" },
      },
      {
        id: 102,
        brand: "realme",
        name: "Narzo 60x 5G",
        imageUrl: "https://rukminim2.flixcart.com/image/832/832/xif0q/mobile/w/s/d/-original-imagtqqdxpp9dzmr.jpeg?q=70&crop=false",
        description: "Slim 5G smartphone with smooth display and fast charging support.",
        price: 15999,
        discount: 14,
        stock: 22,
        color: "Green",
        specs: { ram: "6GB", storage: "128GB", battery: "5000mAh" },
      },
      {
        id: 103,
        brand: "Redmi",
        name: "12 5G",
        imageUrl: "https://rukminim2.flixcart.com/image/832/832/xif0q/mobile/b/i/x/-original-imagsz5wyzhxk8fv.jpeg?q=70&crop=false",
        description: "Budget 5G phone with premium design and solid day-to-day speed.",
        price: 16999,
        discount: 20,
        stock: 18,
        color: "Black",
        specs: { ram: "8GB", storage: "256GB", battery: "5000mAh" },
      },
      {
        id: 104,
        brand: "POCO",
        name: "M6 Pro 5G",
        imageUrl: "https://rukminim2.flixcart.com/image/832/832/xif0q/mobile/r/g/m/-original-imags7g9w7fbutse.jpeg?q=70&crop=false",
        description: "Daily performance phone with stable battery life and bright display.",
        price: 17999,
        discount: 17,
        stock: 16,
        color: "Silver",
        specs: { ram: "6GB", storage: "128GB", battery: "5000mAh" },
      },
      {
        id: 105,
        brand: "motorola",
        name: "g54 5G",
        imageUrl: "https://rukminim2.flixcart.com/image/832/832/xif0q/mobile/a/6/g/-original-imagtc4h2hfcwfzg.jpeg?q=70&crop=false",
        description: "Clean Android experience with OIS camera and stereo speakers.",
        price: 18999,
        discount: 16,
        stock: 25,
        color: "Indigo",
        specs: { ram: "8GB", storage: "128GB", battery: "6000mAh" },
      },
      {
        id: 106,
        brand: "vivo",
        name: "T2x 5G",
        imageUrl: "https://rukminim2.flixcart.com/image/832/832/xif0q/mobile/k/u/q/-original-imagpfbkbyugh8tf.jpeg?q=70&crop=false",
        description: "High-value 5G device with efficient chipset and balanced camera setup.",
        price: 17499,
        discount: 13,
        stock: 21,
        color: "Marine",
        specs: { ram: "6GB", storage: "128GB", battery: "5000mAh" },
      },
    ],
  },
  {
    category: "TV & Audio",
    products: [
      {
        id: 201,
        brand: "Sony",
        name: "Bravia 43-inch 4K Smart TV",
        imageUrl: "https://rukminim2.flixcart.com/image/832/832/xif0q/television/o/x/l/-original-imagrhkhwgnzfmzr.jpeg?q=70&crop=false",
        description: "4K smart TV with vivid visuals and streaming-ready smart features.",
        price: 38999,
        discount: 22,
        stock: 10,
        color: "Black",
        specs: { ram: "2GB", storage: "16GB", battery: "N/A" },
      },
      {
        id: 202,
        brand: "Samsung",
        name: "Crystal Vision 55-inch Smart TV",
        imageUrl: "https://rukminim2.flixcart.com/image/832/832/xif0q/television/m/v/f/-original-imagty2uz7f4sz7b.jpeg?q=70&crop=false",
        description: "Large screen television with sharp color and slim bezel styling.",
        price: 46999,
        discount: 19,
        stock: 8,
        color: "Graphite",
        specs: { ram: "2GB", storage: "16GB", battery: "N/A" },
      },
      {
        id: 203,
        brand: "boAt",
        name: "Aavante Bar 1200 Soundbar",
        imageUrl: "https://rukminim2.flixcart.com/image/832/832/xif0q/speaker/soundbar/h/x/f/aavante-bar-1200-boat-original-imagq9m7x9g9gkzg.jpeg?q=70&crop=false",
        description: "Powerful soundbar with wired subwoofer for a room-filling audio setup.",
        price: 11999,
        discount: 25,
        stock: 14,
        color: "Black",
        specs: { ram: "Bluetooth 5.3", storage: "Multiple Inputs", battery: "N/A" },
      },
      {
        id: 204,
        brand: "JBL",
        name: "Flip Essential 2 Speaker",
        imageUrl: "https://rukminim2.flixcart.com/image/832/832/xif0q/speaker/mobile-tablet-speaker/e/p/j/-original-imagrzchczpcjszg.jpeg?q=70&crop=false",
        description: "Portable speaker with signature JBL tuning and strong battery output.",
        price: 6999,
        discount: 15,
        stock: 19,
        color: "Black",
        specs: { ram: "Bluetooth 5.1", storage: "Portable", battery: "10 Hours" },
      },
      {
        id: 205,
        brand: "Noise",
        name: "Tune Charge Neckband",
        imageUrl: "https://rukminim2.flixcart.com/image/832/832/xif0q/headphone/o/b/f/-original-imagp6skfbnypq5m.jpeg?q=70&crop=false",
        description: "Wireless neckband with fast charging and balanced all-day audio.",
        price: 1499,
        discount: 32,
        stock: 32,
        color: "Blue",
        specs: { ram: "ENC Mic", storage: "Wireless", battery: "40 Hours" },
      },
      {
        id: 206,
        brand: "OnePlus",
        name: "Nord Buds 2r",
        imageUrl: "https://rukminim2.flixcart.com/image/832/832/xif0q/headphone/tws/4/e/k/-original-imagtc44nk4b3hfg.jpeg?q=70&crop=false",
        description: "True wireless buds with bass tuning and everyday fit comfort.",
        price: 2199,
        discount: 29,
        stock: 27,
        color: "Grey",
        specs: { ram: "TWS", storage: "Pocket Case", battery: "38 Hours" },
      },
    ],
  },
  {
    category: "Fashion",
    products: [
      {
        id: 301,
        brand: "Elite Fashion",
        name: "Embroidered Bollywood Georgette Saree",
        imageUrl: "https://rukminim2.flixcart.com/image/612/612/xif0q/sari/h/7/f/free-xxxkn1-6368-wine-ethina-fashion-unstitched-original-imahhsm879kgxsfh.jpeg?q=70",
        description: "Festive saree with embroidered styling and flowing georgette drape.",
        price: 2199,
        discount: 28,
        stock: 35,
        color: "Brown",
        specs: { ram: "Georgette", storage: "Free Size", battery: "Wash Care Included" },
      },
      {
        id: 302,
        brand: "Fashion4Word",
        name: "Women Printed Pure Cotton Anarkali Kurta",
        imageUrl: "https://rukminim2.flixcart.com/image/612/612/xif0q/kurta/8/z/g/xxl-f4w-r-maternity-1058-fashion4word-original-imahhfvtbubq2dgn.jpeg?q=70",
        description: "Printed anarkali kurta in breathable cotton for elegant daily wear.",
        price: 1499,
        discount: 24,
        stock: 42,
        color: "Blue",
        specs: { ram: "Pure Cotton", storage: "XXL", battery: "Wash Care Included" },
      },
      {
        id: 303,
        brand: "BEING WANTED",
        name: "Men Full Sleeve Solid Hooded Sweatshirt",
        imageUrl: "https://rukminim2.flixcart.com/image/612/612/xif0q/sweatshirt/7/g/k/xl-men-zip-sweatshirt-black-xl-ruggstar-original-imahhsnrzwgwfecg.jpeg?q=70",
        description: "Casual hooded sweatshirt designed for winter layering and streetwear fits.",
        price: 1699,
        discount: 30,
        stock: 26,
        color: "Black",
        specs: { ram: "Cotton Blend", storage: "XL", battery: "Wash Care Included" },
      },
      {
        id: 304,
        brand: "Samyani Fashion",
        name: "Woven Banarasi Art Silk Saree",
        imageUrl: "https://rukminim2.flixcart.com/image/612/612/xif0q/sari/w/i/q/free-eta-samyani-fashion-unstitched-original-imahm3y6vhdgffzd.jpeg?q=70",
        description: "Traditional woven saree with banarasi-inspired festive detail.",
        price: 1999,
        discount: 18,
        stock: 17,
        color: "Blue",
        specs: { ram: "Art Silk", storage: "Free Size", battery: "Wash Care Included" },
      },
      {
        id: 305,
        brand: "Disha Fashion",
        name: "Embroidered Banarasi Georgette Saree",
        imageUrl: "https://rukminim2.flixcart.com/image/612/612/xif0q/sari/a/4/e/free-4-mirror-kaju-black-disha-fashion-unstitched-original-imah4zjrzjwgxgmh.jpeg?q=70",
        description: "Banarasi-inspired georgette saree for elevated festive styling.",
        price: 2099,
        discount: 23,
        stock: 24,
        color: "Grey",
        specs: { ram: "Georgette", storage: "Free Size", battery: "Wash Care Included" },
      },
      {
        id: 306,
        brand: "BN Fashion",
        name: "Floral Print Handloom Pure Cotton Saree",
        imageUrl: "https://rukminim2.flixcart.com/image/612/612/xif0q/sari/g/l/c/free-shiuli-khadi-saree-8642-riddhiman-fashion-no-blouse-original-imahe489bwygt8hb.jpeg?q=70",
        description: "Soft cotton saree with floral pattern and handloom-inspired texture.",
        price: 1399,
        discount: 21,
        stock: 33,
        color: "Light Green",
        specs: { ram: "Pure Cotton", storage: "Free Size", battery: "Wash Care Included" },
      },
    ],
  },
  {
    category: "Appliances",
    products: [
      {
        id: 401,
        brand: "Philips",
        name: "Air Fryer NA120/00",
        imageUrl: "https://rukminim2.flixcart.com/image/832/832/xif0q/air-fryer/v/p/r/-original-imagzq8k6lqfzg4z.jpeg?q=70&crop=false",
        description: "Compact air fryer built for fast oil-free cooking.",
        price: 7499,
        discount: 20,
        stock: 13,
        color: "Black",
        specs: { ram: "1500W", storage: "4.2 L", battery: "Energy Efficient" },
      },
      {
        id: 402,
        brand: "Prestige",
        name: "Electric Rice Cooker PRWO 1.8",
        imageUrl: "https://rukminim2.flixcart.com/image/832/832/k6mibgw0/electric-cooker/e/b/k/prestige-prwo-1-8-2-original-imafpffvkwg6zh6f.jpeg?q=70&crop=false",
        description: "Family-size rice cooker for daily quick meal preparation.",
        price: 3299,
        discount: 17,
        stock: 22,
        color: "White",
        specs: { ram: "700W", storage: "1.8 L", battery: "Energy Efficient" },
      },
      {
        id: 403,
        brand: "Bajaj",
        name: "DX 6 Dry Iron",
        imageUrl: "https://rukminim2.flixcart.com/image/832/832/iron/u/m/h/bajaj-dx-6-original-imafz6x9nnvkk4zd.jpeg?q=70&crop=false",
        description: "Durable dry iron with non-stick coated soleplate.",
        price: 999,
        discount: 12,
        stock: 40,
        color: "White",
        specs: { ram: "1000W", storage: "Compact", battery: "Energy Efficient" },
      },
      {
        id: 404,
        brand: "Butterfly",
        name: "Rapid Plus Mixer Grinder",
        imageUrl: "https://rukminim2.flixcart.com/image/832/832/xif0q/mixer-grinder-juicer/8/q/p/-original-imagzgthd6nrwz7d.jpeg?q=70&crop=false",
        description: "Kitchen mixer grinder for blending and everyday grinding tasks.",
        price: 4899,
        discount: 19,
        stock: 16,
        color: "Silver",
        specs: { ram: "750W", storage: "3 Jars", battery: "Energy Efficient" },
      },
      {
        id: 405,
        brand: "Havells",
        name: "Instanio 3L Water Heater",
        imageUrl: "https://rukminim2.flixcart.com/image/832/832/water-geyser/z/r/s/instanio-3l-havells-original-imaeszy6dw7pew6k.jpeg?q=70&crop=false",
        description: "Compact instant geyser designed for quick hot water delivery.",
        price: 3999,
        discount: 15,
        stock: 14,
        color: "White",
        specs: { ram: "3000W", storage: "3 L", battery: "Energy Efficient" },
      },
      {
        id: 406,
        brand: "Pigeon",
        name: "Favourite Electric Kettle",
        imageUrl: "https://rukminim2.flixcart.com/image/832/832/kettle-water-boiler/f/y/z/pigeon-favourite-original-imafum9phzwsufyg.jpeg?q=70&crop=false",
        description: "Fast-boil kettle for tea, coffee, and quick kitchen prep use.",
        price: 1399,
        discount: 26,
        stock: 29,
        color: "Silver",
        specs: { ram: "1500W", storage: "1.5 L", battery: "Energy Efficient" },
      },
    ],
  },
];

const FALLBACK_PRODUCTS = FALLBACK_CATEGORY_CONFIG.flatMap((group) =>
  group.products.map((product, index) => ({
    id: product.id,
    sku: `QAC-${product.id}`,
    slug: `${group.category.toLowerCase().replace(/[^a-z0-9]+/g, "-")}-${product.id}`,
    name: product.name,
    brand: product.brand,
    category: group.category,
    description: product.description,
    price: product.price,
    discount: product.discount,
    stock: product.stock,
    maxStock: product.stock + 20 + index,
    imageUrl: product.imageUrl,
    rating: (4 + ((index + 2) % 10) / 10).toFixed(1),
    reviewCount: 70 + index * 17,
    featured: index % 2 === 0,
    flashSale: index % 3 === 0,
    color: product.color,
    ram: product.specs.ram,
    storage: product.specs.storage,
    battery: product.specs.battery,
  }))
);

const DUMMYJSON_CATEGORY_MAP = {
  "Phones & Tablets": ["smartphones", "tablets"],
  "TV & Audio": ["mobile-accessories", "laptops"],
  Fashion: [
    "mens-shirts",
    "mens-shoes",
    "mens-watches",
    "tops",
    "womens-dresses",
    "womens-shoes",
    "womens-watches",
    "womens-bags",
    "womens-jewellery",
    "sunglasses",
  ],
  Appliances: ["kitchen-accessories", "home-decoration", "furniture"],
};

const getCategoryDefaults = (category, product = {}) => {
  if (category === "Phones & Tablets") {
    return {
      seller: "QA Coder Digital Store",
      warranty: "1 Year Brand Warranty",
      returnPolicy: "7 day replacement available",
      delivery: "Free delivery in 2-4 business days",
      highlights: [
        `${product.ram || "8GB"} RAM for multitasking`,
        `${product.storage || "128GB"} storage for apps and media`,
        `${product.battery || "5000mAh"} battery for long screen time`,
        product.processor || "Optimized chipset for smooth everyday usage",
      ],
      attributes: {
        display: product.display || "6.6-inch FHD+ display",
        processor: product.processor || "Octa-core 5G processor",
        camera: product.camera || "50MP main camera setup",
        battery: product.battery || "5000mAh battery",
        connectivity: product.connectivity || "5G, Wi-Fi, Bluetooth",
      },
    };
  }

  if (category === "TV & Audio") {
    return {
      seller: "QA Coder Home Entertainment",
      warranty: "1 Year Comprehensive Warranty",
      returnPolicy: "7 day replacement available",
      delivery: "Installation support available after delivery",
      highlights: [
        product.display || product.screenSize || "Large immersive display or audio profile",
        product.connectivity || "Multiple connectivity options included",
        product.audioOutput || "Enhanced sound tuning for entertainment",
        "Suitable for catalog, review, and checkout automation flows",
      ],
      attributes: {
        display: product.display || product.screenSize || "43-inch display format",
        resolution: product.resolution || "4K / HD ready media playback",
        connectivity: product.connectivity || "HDMI, USB, Bluetooth, Wi-Fi",
        audioOutput: product.audioOutput || "Balanced stereo audio output",
        smartFeatures: product.smartFeatures || "Streaming and smart navigation support",
      },
    };
  }

  if (category === "Fashion") {
    return {
      seller: "QA Coder Fashion Hub",
      warranty: "No warranty on apparel and ethnic wear",
      returnPolicy: "Easy 7 day return on unused items",
      delivery: "Standard delivery in 3-5 business days",
      highlights: [
        product.material || "Comfortable fabric finish",
        product.fit || "Designed for regular day-long wear",
        product.pattern || "Updated styling for modern wardrobe needs",
        product.occasion || "Suitable for casual, office, or festive use",
      ],
      attributes: {
        material: product.material || "Premium blended fabric",
        fit: product.fit || "Regular fit",
        pattern: product.pattern || "Solid / printed styling",
        occasion: product.occasion || "Casual and festive wear",
        care: product.care || "Machine wash as per tag instructions",
      },
    };
  }

  return {
    seller: "QA Coder Home Essentials",
    warranty: "1 Year Limited Warranty",
    returnPolicy: "7 day replacement available",
    delivery: "Free delivery with doorstep service",
    highlights: [
      product.power || "Efficient power usage",
      product.capacity || "Suitable capacity for everyday tasks",
      product.usage || "Made for routine household use",
      "Reliable fit for appliance browsing and purchase automation",
    ],
    attributes: {
      power: product.power || "750W efficient operation",
      capacity: product.capacity || "Family-friendly capacity",
      usage: product.usage || "Everyday kitchen and home usage",
      finish: product.finish || "Compact modern finish",
      efficiency: product.efficiency || "Energy-conscious performance",
    },
  };
};

let remoteCatalogCache = null;
let remoteCatalogPromise = null;

const formatCurrency = (value) =>
  `Rs. ${Number(value || 0).toLocaleString("en-IN")}`;

const optimizeCatalogImageUrl = (imageUrl, targetSize = 320) => {
  if (!imageUrl || imageUrl.startsWith("data:image")) {
    return imageUrl || FALLBACK_PRODUCT_IMAGE;
  }

  if (imageUrl.includes("/image/")) {
    return imageUrl.replace(/\/image\/\d+\/\d+\//, `/image/${targetSize}/${targetSize}/`);
  }

  return imageUrl;
};

const normalizeCategory = (category) => ({
  ...category,
  imageUrl: optimizeCatalogImageUrl(category.imageUrl || FALLBACK_PRODUCT_IMAGE, 320),
});

const getProductImages = (product) => {
  const candidates = [
    product.imageUrl,
    product.image_url,
    product.url,
    product.image,
    product.thumbnail,
    ...(Array.isArray(product.images) ? product.images : []),
  ]
    .filter(Boolean)
    .filter((value, index, values) => values.indexOf(value) === index);

  return candidates.length ? candidates : [FALLBACK_PRODUCT_IMAGE];
};

const normalizeProduct = (product) => {
  const price = Number(product.price || 0);
  const discount = Number(product.discount || 0);
  const currentPriceRaw = Math.max(0, Math.round((price * (100 - discount)) / 100));
  const categoryDefaults = getCategoryDefaults(product.category, product);

  return {
    id: String(product.id),
    sku: product.sku || `QAC-${product.id}`,
    slug: product.slug || String(product.id),
    name: product.name,
    brand: product.brand || "QA Coder",
    category: product.category,
    description: product.description,
    price,
    discount,
    stock: Number(product.stock || 0),
    maxStock: Number(product.maxStock || product.max_stock || product.stock || 0),
    url: product.imageUrl || product.url || product.thumbnail || FALLBACK_PRODUCT_IMAGE,
    listingImageUrl: optimizeCatalogImageUrl(
      product.listingImageUrl || product.thumbnail || product.imageUrl || product.url || FALLBACK_PRODUCT_IMAGE,
      320
    ),
    rating: Number(product.rating || 4.2).toFixed(1),
    reviewCount: Number(product.reviewCount || product.review_count || 0),
    featured: Boolean(product.featured),
    flashSale: Boolean(product.flashSale || product.flash_sale),
    color: product.color || "Default",
    specs: {
      ram: product.ram || "General Use",
      storage: product.storage || "Standard",
      battery: product.battery || "N/A",
    },
    highlights: Array.isArray(product.highlights) && product.highlights.length
      ? product.highlights
      : categoryDefaults.highlights,
    seller: product.seller || categoryDefaults.seller,
    warranty: product.warranty || categoryDefaults.warranty,
    returnPolicy: product.returnPolicy || categoryDefaults.returnPolicy,
    delivery: product.delivery || categoryDefaults.delivery,
    attributes: {
      ...categoryDefaults.attributes,
      ...(product.attributes || {}),
    },
    currentPriceRaw,
    currentPriceFormatted: formatCurrency(currentPriceRaw),
    originalPriceFormatted: formatCurrency(price),
    discountPercent: `${discount}% OFF`,
    reviewsLabel: `${Number(product.reviewCount || product.review_count || 0).toLocaleString("en-IN")} reviews`,
    images: getProductImages(product),
  };
};

const getFallbackProducts = (params = {}) => {
  const { category, search, limit, featured, flashSale } = params;
  const parseFlag = (value) => value === true || value === "true" || value === 1 || value === "1";

  let filtered = [...FALLBACK_PRODUCTS];

  if (category) {
    filtered = filtered.filter((product) => product.category === category);
  }

  if (search) {
    const query = String(search).toLowerCase();
    filtered = filtered.filter((product) =>
      [product.name, product.brand, product.description, product.category]
        .join(" ")
        .toLowerCase()
        .includes(query)
    );
  }

  if (featured !== undefined) {
    filtered = filtered.filter((product) => product.featured === parseFlag(featured));
  }

  if (flashSale !== undefined) {
    filtered = filtered.filter((product) => product.flashSale === parseFlag(flashSale));
  }

  const safeLimit = Math.min(Math.max(Number.parseInt(limit, 10) || filtered.length, 1), 200);
  return filtered.slice(0, safeLimit).map(normalizeProduct);
};

const getFallbackCategories = () =>
  FALLBACK_CATEGORY_CONFIG.map((group) =>
    normalizeCategory({
      category: group.category,
      productCount: FALLBACK_PRODUCTS.filter((product) => product.category === group.category).length,
      imageUrl: group.products[0]?.imageUrl || FALLBACK_PRODUCT_IMAGE,
    })
  );

const toQueryString = (params = {}) => {
  const query = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      query.set(key, String(value));
    }
  });

  return query.toString();
};

async function fetchJson(url, timeoutMs) {
  const controller = new AbortController();
  const timeoutId = window.setTimeout(() => controller.abort(), timeoutMs);

  try {
    const response = await fetch(url, { signal: controller.signal });
    if (!response.ok) {
      throw new Error(`Request failed with status ${response.status}`);
    }
    return response.json();
  } finally {
    window.clearTimeout(timeoutId);
  }
}

const mapRemoteCategory = (remoteCategory) => {
  const matchedEntry = Object.entries(DUMMYJSON_CATEGORY_MAP).find(([, categories]) =>
    categories.includes(remoteCategory)
  );

  return matchedEntry?.[0] || null;
};

const buildRemoteProduct = (product, index) => {
  const mappedCategory = mapRemoteCategory(product.category);
  if (!mappedCategory) {
    return null;
  }

  const displayPrice = Math.round(Number(product.price || 0) * 89);
  const reviewCount = Array.isArray(product.reviews) && product.reviews.length > 0
    ? product.reviews.length
    : 45 + index * 3;
  const primaryImage = product.thumbnail || product.images?.[0] || FALLBACK_PRODUCT_IMAGE;
  const title = `${product.title}`.trim();

  return {
    id: `remote-${product.id}`,
    sku: `QAC-REMOTE-${product.id}`,
    slug: `${mappedCategory.toLowerCase().replace(/[^a-z0-9]+/g, "-")}-${product.id}`,
    name: title,
    brand: product.brand || "QA Coder",
    category: mappedCategory,
    description: product.description || `Practical ecommerce product for ${mappedCategory.toLowerCase()} automation flows.`,
    price: displayPrice,
    discount: Math.round(Number(product.discountPercentage || 0)),
    stock: Number(product.stock || 0),
    maxStock: Number(product.stock || 0) + 18,
    imageUrl: primaryImage,
    images: (Array.isArray(product.images) ? product.images : [primaryImage]).filter(Boolean),
    rating: Number(product.rating || 4.2).toFixed(1),
    reviewCount,
    featured: Number(product.rating || 0) >= 4.5 || index % 2 === 0,
    flashSale: Number(product.discountPercentage || 0) >= 10 || index % 3 === 0,
    color: product.meta?.barcode ? "Assorted" : "Default",
    seller: mappedCategory === "Fashion" ? "Marketplace Fashion Partner" : "QA Coder Verified Seller",
    delivery:
      mappedCategory === "TV & Audio"
        ? "Free installation-ready delivery in 3-6 business days"
        : "Free delivery in 2-5 business days",
    returnPolicy:
      mappedCategory === "Fashion"
        ? "7 day return on unused products"
        : "7 day replacement available",
    warranty:
      mappedCategory === "Fashion"
        ? "No warranty on fashion products"
        : mappedCategory === "Phones & Tablets"
          ? "1 Year Brand Warranty"
          : "1 Year Limited Warranty",
    ram:
      mappedCategory === "Phones & Tablets"
        ? "8GB"
        : mappedCategory === "Fashion"
          ? "Fabric Detail"
          : mappedCategory === "TV & Audio"
            ? "Wireless / Smart"
            : "Home Use",
    storage:
      mappedCategory === "Phones & Tablets"
        ? "128GB"
        : mappedCategory === "Fashion"
          ? "Standard Size"
          : mappedCategory === "TV & Audio"
            ? "Smart Media"
            : "General Capacity",
    battery:
      mappedCategory === "Phones & Tablets"
        ? "5000mAh"
        : mappedCategory === "TV & Audio"
          ? "Long Play"
          : mappedCategory === "Appliances"
            ? "Energy Efficient"
            : "Wash Care Included",
    processor:
      mappedCategory === "Phones & Tablets" ? "Snapdragon / Dimensity class chipset" : undefined,
    display:
      mappedCategory === "Phones & Tablets"
        ? "6.5-inch to 6.8-inch immersive display"
        : mappedCategory === "TV & Audio"
          ? "Large display or compact audio form factor"
          : undefined,
    camera: mappedCategory === "Phones & Tablets" ? "Dual / triple rear camera setup" : undefined,
    connectivity:
      mappedCategory === "Phones & Tablets"
        ? "5G, Wi-Fi, Bluetooth"
        : mappedCategory === "TV & Audio"
          ? "Bluetooth, HDMI, USB, Wi-Fi"
          : undefined,
    audioOutput: mappedCategory === "TV & Audio" ? "Clear vocal and bass-balanced audio" : undefined,
    smartFeatures: mappedCategory === "TV & Audio" ? "Streaming-ready smart controls" : undefined,
    material:
      mappedCategory === "Fashion"
        ? product.category.includes("shoes")
          ? "Synthetic / mesh upper"
          : "Cotton blend / premium fabric"
        : undefined,
    fit:
      mappedCategory === "Fashion"
        ? product.category.includes("shoes")
          ? "Comfort fit"
          : "Regular fit"
        : undefined,
    pattern:
      mappedCategory === "Fashion"
        ? product.category.includes("watches")
          ? "Minimal contemporary finish"
          : "Solid / printed pattern"
        : undefined,
    occasion: mappedCategory === "Fashion" ? "Casual, office, and festive styling" : undefined,
    care: mappedCategory === "Fashion" ? "Handle and wash as per care instructions" : undefined,
    power: mappedCategory === "Appliances" ? "Efficient powered operation" : undefined,
    capacity: mappedCategory === "Appliances" ? "Standard household capacity" : undefined,
    usage: mappedCategory === "Appliances" ? "Everyday kitchen and home usage" : undefined,
    finish: mappedCategory === "Appliances" ? "Compact modern finish" : undefined,
    efficiency: mappedCategory === "Appliances" ? "Energy-conscious performance" : undefined,
  };
};

async function fetchRemoteCatalogProducts() {
  if (remoteCatalogCache) {
    return remoteCatalogCache;
  }

  if (!remoteCatalogPromise) {
    remoteCatalogPromise = fetchJson(REMOTE_PRODUCTS_API_URL, REMOTE_REQUEST_TIMEOUT_MS)
      .then((response) => {
        const products = Array.isArray(response.products) ? response.products : [];
        remoteCatalogCache = products
          .map(buildRemoteProduct)
          .filter(Boolean)
          .map(normalizeProduct);
        return remoteCatalogCache;
      })
      .catch((error) => {
        remoteCatalogPromise = null;
        throw error;
      });
  }

  return remoteCatalogPromise;
}

async function fetchLocalCatalogProducts(params = {}) {
  const queryString = toQueryString(params);
  const localProductsUrl = `http://localhost:5000/api/products${queryString ? `?${queryString}` : ""}`;
  const products = await fetchJson(localProductsUrl, REQUEST_TIMEOUT_MS);
  return products.map(normalizeProduct);
}

function applyProductFilters(products, params = {}) {
  const { category, search, limit, featured, flashSale } = params;
  const parseFlag = (value) => value === true || value === "true" || value === 1 || value === "1";

  let filtered = [...products];

  if (category) {
    filtered = filtered.filter((product) => product.category === category);
  }

  if (search) {
    const query = String(search).trim().toLowerCase();
    filtered = filtered.filter((product) =>
      [product.name, product.brand, product.category, product.description]
        .join(" ")
        .toLowerCase()
        .includes(query)
    );
  }

  if (featured !== undefined) {
    filtered = filtered.filter((product) => product.featured === parseFlag(featured));
  }

  if (flashSale !== undefined) {
    filtered = filtered.filter((product) => product.flashSale === parseFlag(flashSale));
  }

  filtered.sort(
    (first, second) =>
      Number(second.flashSale) - Number(first.flashSale) ||
      Number(second.featured) - Number(first.featured) ||
      Number(second.reviewCount) - Number(first.reviewCount)
  );

  const safeLimit = Math.min(Math.max(Number.parseInt(limit, 10) || filtered.length, 1), 200);
  return filtered.slice(0, safeLimit);
}

export async function fetchProducts(params = {}) {
  try {
    const remoteProducts = await fetchRemoteCatalogProducts();
    return applyProductFilters(remoteProducts, params);
  } catch (remoteError) {
    console.warn("Using fallback product catalog because remote catalog is unavailable.", remoteError);

    try {
      return await fetchLocalCatalogProducts(params);
    } catch (localError) {
      console.warn("Using local fallback product catalog because localhost products API is unavailable.", localError);
      return getFallbackProducts(params);
    }
  }
}

export async function fetchProductById(id) {
  try {
    const products = await fetchRemoteCatalogProducts();
    const matchedProduct = products.find((product) => String(product.id) === String(id));
    if (matchedProduct) {
      return matchedProduct;
    }
  } catch (error) {
    console.warn("Remote product lookup failed, attempting local fallbacks.", error);
  }

  const fallbackProduct =
    FALLBACK_PRODUCTS.find((product) => String(product.id) === String(id)) ||
    getFallbackProducts({ limit: 200 }).find((product) => String(product.id) === String(id));

  if (fallbackProduct) {
    return normalizeProduct(fallbackProduct);
  }

  const localProduct = await fetchJson(`http://localhost:5000/api/products/${id}`, REQUEST_TIMEOUT_MS);
  return normalizeProduct(localProduct);
}

export async function fetchCategories() {
  try {
    const products = await fetchRemoteCatalogProducts();
    const grouped = Object.keys(DUMMYJSON_CATEGORY_MAP).map((category) => {
      const categoryProducts = products.filter((product) => product.category === category);
      return normalizeCategory({
        category,
        productCount: categoryProducts.length,
        imageUrl: categoryProducts[0]?.url || FALLBACK_PRODUCT_IMAGE,
      });
    });

    return grouped.filter((category) => category.productCount > 0);
  } catch (error) {
    console.warn("Using fallback categories because remote catalog is unavailable.", error);
    return getFallbackCategories();
  }
}

export { FALLBACK_PRODUCT_IMAGE };
